import script from "./ListarValores.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarValores.vue?vue&type=script&setup=true&lang=js"

import "./ListarValores.vue?vue&type=style&index=0&id=131da8c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-131da8c4"]])

export default __exports__